<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          to="/ajouter-ProduitRestreint"
        >
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          Ajouter une produit restreint
        </router-link>
        <!-- <button
          class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
        >
          Exporter
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button> -->
      </div>

      <div class="d-flex align-items-center">
        <form class="search-box position-relative me-15" @submit.prevent="rechercher">
          <input type="text" name="mot" v-model="searchTerm" @keyup="rechercher"
                 class="form-control shadow-none text-black rounded-0 border-0"
                 placeholder="Rechercher par type de restriction" />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th>Type de restriction</th>
              <th>Hs Code</th>
              <th>Catégorie de produit</th>
              <th>Pays</th>
              <th>Régime douanier</th>
              <th>Type de Document</th>
              <th>Statut</th>
              <th class="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in prodRestreints" :key="index">
              <td>
                <span v-if="item.restriction_type === 'FORBIDDEN'" class="badge bg-danger">Interdit</span>
                <span v-else-if="item.restriction_type === 'LICENSE_REQUIRED'" class="badge bg-warning">Licence requise</span>
                <span v-else-if="item.restriction_type === 'SPECIAL_TAX'" class="badge bg-info">Taxe spéciale</span>
                <span v-else-if="item.restriction_type === 'QUOTA_LIMITED'" class="badge bg-secondary">Quantité limitée</span>
                <span v-else class="text-muted">-</span>
              </td>
              <td>{{ item.hscode?.product || '-' }}</td>
              <td>{{ item.categorieProduit?.name || '-' }}</td>
              <td>{{ item.pays?.name_fr || '-' }}</td>
              <td>{{ item.regimedouanier?.name || '-' }}</td>
              <td>{{ item.typeD?.libelle || '-' }}</td>
              <td>
                <span v-if="item.is_active" class="badge bg-success">Actif</span>
                <span v-else class="badge bg-secondary">Inactif</span>
              </td>
              <td class="text-end pe-0">
                <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle"
                        data-bs-toggle="dropdown" aria-expanded="false">
                    Actions
                    <i class="flaticon-chevron-2 ms-5 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                   <li >
                      <router-link :to="{ name: 'EditProduitRestreintPage', params: { id: item.id } }" 
                          class="dropdown-item d-flex align-items-center"><i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>Modifier</router-link>
                    </li>
                    <li>
                      <a class="dropdown-item d-flex align-items-center"
                         href="javascript:void(0);"
                         @click="suppression(item.id, prodRestreints, 'restricted', 'restricted')">
                        <i class="flaticon-delete me-8"></i> Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination-area d-md-flex mt-15 justify-content-between align-items-center">
        <PaginationComponent
          :page="page"
          :totalPages="totalPages"
          :totalElements="totalElements"
          :limit="limit"
          @paginate="handlePaginate"
        />
      </div>
    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import ApiService from "../../services/ApiService";
import PaginationComponent from "../../components/Utilities/Pagination.vue";
import { suppression, error } from "../../utils/utils";
import { RuleSet } from "@/models/RuleSet";
import AddProduitRestreintModal from "./AddProduitRestreintModal.vue";
import { ProduitRestreint } from "@/models/ProduitRestreint";

export default defineComponent({
  name: "ListeProduitRestreintPage",
  components: {
    PaginationComponent
    
  },

  setup() {
    const prodRestreints = ref<Array<ProduitRestreint>>([]);
    const selectedItem = ref(0);

    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    function getAllProduitRestreint(page_ = 1, limit_ = 10, mot = '') {
      return ApiService.get(`restricteds?page=${page_}&limit=${limit_}&mot=${mot}&`)
        .then(({ data }) => {
        console.log("recupppp",data);
          prodRestreints.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
        })
        .catch(({ response }) => error(response.data.message));
    }

    function rechercher() {
      getAllProduitRestreint(page.value, limit.value, searchTerm.value);
    }

    const handlePaginate = ({ page_, limit_ }) => {
      page.value = page_;
      getAllProduitRestreint(page_, limit_, searchTerm.value);
    };

    function moddifier(item: RuleSet) {
      selectedItem.value = item.id;
    }

    function recharger() {
      getAllProduitRestreint();
    }

    onMounted(() => {
      getAllProduitRestreint();
    });

    return {
      prodRestreints,
      suppression,
      page,
      limit,
      totalPages,
      totalElements,
      searchTerm,
      rechercher,
      handlePaginate,
      selectedItem,
      recharger,
      moddifier
    };
  }
});
</script>
